import React from 'react';

import { useMobileRobotViewAvailability } from '../../../../utils/hooks';
import { useRobotSelector } from '../../context';
import { RobotViewPythonMobile } from './_mobile/robot_view_python_mobile';
import { RobotViewPythonDesktop } from './_desktop/robot_view_python_desktop';

export const RobotViewPython = () => {
    const shouldShowMobileRobotView = useMobileRobotViewAvailability(useRobotSelector((context) => context.problem));

    return shouldShowMobileRobotView ? <RobotViewPythonMobile /> : <RobotViewPythonDesktop />;
};
